'use client'

import { notFound, useTranslations } from '@/lib/next-shim'

import { useConsultationLivePage } from '../model/useConsultationLivePage'
import { ConsultationLiveView } from './ConsultationLiveView'

export function ConsultationLivePage() {
  const t = useTranslations('common')
  const { loading, error, refetch, ready, consultation, patientId } = useConsultationLivePage()

  if (loading) return <div className="p-10 text-center">{t('loading')}</div>
  if (error) {
    console.error('[ConsultationLivePage] failed to load patient:', error)
    return (
      <div className="p-10 text-center space-y-4">
        <p className="text-gray-700">{t('profileCheckFailed')}</p>
        <button
          type="button"
          onClick={() => refetch()}
          className="inline-flex items-center px-4 py-2 rounded-md text-sm font-medium text-white bg-primary-600 hover:bg-primary-700"
        >
          {t('tryAgain')}
        </button>
      </div>
    )
  }
  // Not ready -> redirecting to complete-profile; show a neutral loader meanwhile.
  if (!ready) return <div className="p-10 text-center">{t('loading')}</div>

  if (!consultation) {
    notFound()
    return null
  }

  return <ConsultationLiveView consultation={consultation} patientId={patientId} />
}
